import { apiClient } from './client'

export interface PendingUserDTO {
  id: number
  login: string
  email: string | null
  first_name: string | null
  last_name: string | null
  image_url: string | null
  requested_at: string | null
  approval_status: string
}

export interface ApproveRequest {
  authorities: string[]
}

export interface RejectRequest {
  reason: string
}

export interface ActionResponse {
  id: number
  approval_status: string
  authorities: string[]
}

const BASE = '/admin/approvals'

export const userApprovalApi = {
  listPending: async (): Promise<PendingUserDTO[]> => {
    const { data } = await apiClient.get(`${BASE}/pending`)
    return data
  },

  authorities: async (): Promise<string[]> => {
    const { data } = await apiClient.get(`${BASE}/authorities`)
    return data
  },

  approve: async (id: number, authorities: string[]): Promise<ActionResponse> => {
    const { data } = await apiClient.post(`${BASE}/${id}/approve`, { authorities })
    return data
  },

  reject: async (id: number, reason: string): Promise<ActionResponse> => {
    const { data } = await apiClient.post(`${BASE}/${id}/reject`, { reason })
    return data
  },

  revoke: async (id: number): Promise<ActionResponse> => {
    const { data } = await apiClient.post(`${BASE}/${id}/revoke`)
    return data
  },
}
